import manifest from "./image-manifest.json";
import fileHashes from "./file-hashes.json";

// Layout-accurate `sizes` presets (the site's content column is capped at 1400px with 40–80px of padding).
export const CARD_SIZES = "(min-width: 1400px) 440px, (min-width: 1024px) 33vw, (min-width: 640px) 50vw, 100vw";
export const HALF_SIZES = "(min-width: 1400px) 660px, (min-width: 768px) 50vw, 100vw";
export const FULL_SIZES = "(min-width: 1400px) 1320px, 100vw";

// Production serves media as /static/media/<name>.<hash8>.<ext> (1-year immutable on the CDN; see scripts/hash-assets.mjs).
// The dev server has no such files, so development/test keep the plain public URLs.
const HASHED = process.env.NODE_ENV === "production";
const hashedUrl = (url, hash) => (HASHED && hash ? url.replace(/^.*\/([^/]+?)(\.[^./]+)$/, (_, name, ext) => `/static/media/${name}.${hash}${ext}`) : url);

// Any public file (video, font, logo, cert badge…) → its long-cache URL when one is known.
export const asset = (url) => hashedUrl(url, fileHashes[url] || manifest[url]?.[3]);

const base = (src, width) => src.replace(/\.(webp|jpe?g|png)$/i, "").replace(new RegExp(`-${width}$`), "");

// Explicit width/height (no layout shift) and, where variants exist, srcset/sizes for any image under /public.
// Generated by scripts/images.mjs (`yarn images`); unknown paths fall back to a plain { src }. A source named with its
// own width ("hero-1280.webp") shares the variant basename ("hero-750.webp"). `max` caps the largest candidate offered.
export function imgProps(src, sizes = CARD_SIZES, max = Infinity) {
  const m = manifest[src];
  if (!m) return { src };
  const [width, height, variants, hash] = m;
  if (!variants.length) return { src: hashedUrl(src, hash), width, height };
  const b = base(src, width);
  const set = variants.filter((w) => w <= max).map((w) => `${hashedUrl(`${b}-${w}.webp`, hash)} ${w}w`);
  if (width <= max || set.length === 0) set.push(`${hashedUrl(src, hash)} ${width}w`);
  return { src: hashedUrl(src, hash), width, height, srcSet: set.join(", "), sizes };
}

// Intrinsic dimensions only (for images whose src is attached later).
export const imgDims = (src) => (manifest[src] ? { width: manifest[src][0], height: manifest[src][1] } : {});

// URL of the smallest generated variant at least `w` wide (or the source when none is).
export function variantUrl(src, w) {
  const m = manifest[src];
  if (!m) return src;
  const [width, , variants, hash] = m;
  const pick = variants.find((v) => v >= w);
  return hashedUrl(pick ? `${base(src, width)}-${pick}.webp` : src, hash);
}
